import { useModal } from '@billy/design-system'
import { Callout, Tag, Typography, XStack, YStack } from '@shinetools/lumen-react'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

// The @components barrel re-exports CreateContactModal, which renders this section.
// Moving the supplier modal out of views/ does not fix this; it can import from @components again once the barrel
// stops re-exporting CreateContactModal and ContactSelect (EXP-660).
// eslint-disable-next-line @billy/shine-accounting/consistent-alias-imports -- importing the barrel from here cycles back through CreateContactModal
import { UpgradeSubscriptionModal } from '../../../../components/Modal/upgradeSubscriptionModal'
import { ModalId } from '../../../../enums/modalId'
import { useComponentId } from '../../../../hooks'
import type { WithTrackingContext } from '../../../../types/withTrackingContext'

export const AutomationUpgradeSection = ({ trackingContext }: WithTrackingContext) => {
  const { t } = useTranslation()
  const upgradeModalId = useComponentId(ModalId.UpgradeSubscriptionModal)
  const { open: openUpgradeSubscriptionModal } = useModal(upgradeModalId)

  const handleUpgradeAction = useCallback(() => {
    openUpgradeSubscriptionModal()
  }, [openUpgradeSubscriptionModal])

  return (
    <YStack gap={24}>
      <XStack align="center" justify="space-between">
        <Typography.Text size="large" weight="semibold">
          {t('suppliers.detail.automation.title')}
        </Typography.Text>
        <Tag color="neutral" label={t('organization_subscription.plus')} size="small" type="subtle" />
      </XStack>
      <Callout
        actionLabel={t('suppliers.detail.automation.upgrade.action')}
        color="informative"
        message={t('suppliers.detail.automation.upgrade.message')}
        onAction={handleUpgradeAction}
        showButton
      />
      <UpgradeSubscriptionModal id={upgradeModalId} trackingContext={trackingContext} />
    </YStack>
  )
}
